import { getTopFunds } from 'bff/hooks/reporting/TopFundsApi';
import FundCard from './FundCard';
import styles from './topFunds.module.scss';
import { useQuery } from '@tanstack/react-query';
import WidgetLoader from '../../../../atoms/widget-loader/WidgetLoader';
import WidgetError from '../../../../atoms/widget-error/WidgetError';
import { Suspense, useContext, useEffect } from 'react';
import { WidgetContext } from 'modules/dashboard/components/organisms/widget/Widget';
import { useSetWidgetQueryStatus } from 'modules/dashboard/types/widgets/widget.hooks';

const TopFundsWidget = () => {
  const context = useContext(WidgetContext);

  const {
    data: topFunds,
    isFetching,
    isError,
    refetch,
    isSuccess
  } = useQuery(getTopFunds({ clientId: 1 }));

  useEffect(() => {
    if (!context) return;
    context.setReloadHandler(() => () => {
      refetch();
    });
  }, []);

  useSetWidgetQueryStatus({ isFetching, isError, isSuccess, context });

  return (
    <Suspense fallback={<WidgetLoader />}>
      {isFetching ? (
        <div className={styles.loaderContainer}>
          <WidgetLoader />
        </div>
      ) : isError ? (
        <WidgetError onRefresh={refetch} isRefreshing={isFetching} />
      ) : (
        <div className={styles.container} data-testid={`topFundsContainer`}>
          {topFunds?.map((fund, index) => (
            <FundCard
              key={index}
              index={index}
              name={fund.fundName}
              shortName={fund.fundShortName}
              amount={fund.amount}
              percentageOfBook={fund.bookValue}
              percentageGrowth={fund.growthPercentage}
              isPositiveGrowth={Number(fund.growthPercentage) > 0 ? true : false}
              data={fund.fundHistory}
              labels={fund.fundHistoryLabels}
            />
          ))}
        </div>
      )}
    </Suspense>
  );
};

export default TopFundsWidget;
